// RETURNS ALL EVENT OBJECTS CLOSEST TO TODAY'S DATE
export function findRecentEvents(array) {
  const today = new Date(Date.now());
  const orderedEvents = array.sort((a, b) => {
    const dateA = new Date(a.eventDate);
    const today = new Date(Date.now());
    const dateB = new Date(b.eventDate);
    return dateA - dateB;
  });

  console.log('array sorted: ', orderedEvents);

  const events = orderedEvents.filter((e) => {
    let startTime = e.startTime;
    if (!startTime || startTime === '') {
      startTime = '11:59 PM';
    }
    const [hour, minute, ampm] = startTime
      .trim()
      .replace(/(\d)\s?(am|pm)/i, '$1:$2')
      .split(':');
    const utcFormatHour =
      ampm.toLowerCase() === 'pm' && hour < 12 ? hour * 1 + 12 : hour;
    const eventDate = new Date(`${e.eventDate}T${(`0${utcFormatHour}`).slice(-2)}:${minute}`).getTime();
    return eventDate >= today;
  });
  return events;
}

// RETURNS CLOSEST STORY OBJECTS TO TODAY'S DATE
export function findRecentStories(array) {
  const orderedStories = array.sort((a, b) => {
    const dateA = new Date(a.publishedDate);
    const dateB = new Date(b.publishedDate);
    return dateB - dateA;
  });
  return orderedStories;
}

// Month, date, year format
export function formatDate(date) {
  const parts = date.split('-');
  const year = parts[0].slice(-2);
  const order = parts.slice(1, 3).concat(year);
  return order.join('/').replace(/(^|\/)0+/g, '$1');
}

const dateFormat = require('dateformat');

export function longDate(date) {
  return dateFormat(date, 'mmmm dS, yyyy', true);
}

// RETURNS A BOOLEN VALUE FOR IF ON THE DOWNTOWN MAP PAGE
export function checkMap(l) {
  if (l === '/downtown-map/' || l === '/downtown-map') {
    return true;
  }
  return false;
}

// Capitalize the first letter of each word of a given string
export function capitalize(str) {
  str = str.split(' ');

  for (let i = 0, x = str.length; i < x; i++) {
    str[i] = str[i][0].toUpperCase() + str[i].substr(1);
  }

  return str.join(' ');
}

/**
 * Return a copy of a given URL, appending a '/' unless it already ends in one.
 * Attempts to not add it to external URLs.
 *
 * @param {string} someUrl Any string, intended to be used for URLs.
 */
export function endSlash(someUrl) {
  if (someUrl.endsWith('/')) {
    return someUrl;
  }
  return someUrl.match(/(https?:\/\/(www\.)?venturerichmond\.com)|^\//) ? `${someUrl}/` : someUrl;
}

/**
 * Return `true` if the page should have a meta tag in the header like
 * <meta data-react-helmet="true" name="robots" content="noindex">, `false` otherwise.
 */
export function notIndex(route) {
  const pagesNotIndexed = [
    /\/our-events\/2nd-street-festival-2016\//,
    /\/our-events\/2nd-street-festival-2017\//,
    /\/our-events\/2nd-street-festival-2018\//,
    /\/our-events\/2nd-street-festival-2019\//,
    /\/our-events\/2nd-street-festival-2020\//,
    /\/our-events\/dominion-energy-riverrock\/2020\//,
    /\/our-events\/richmond-folk-festival\/2020\//,
    /\/our-events\/featured-events\/polar-express\//,
    /\/our-events\/movies-on-browns-island\//,
    /^\/work-downtown\/commercial-facts\/$/,
    /^\/news\/downtown-richmond-thanksgiving-2020-dining-and-take-out\/$/,
    /^\/news\/celebrate-juneteenth-2022-richmond\/$/,
    /^\/news\/how-to-celebrate-juneteenth\/$/,
    /^\/news\/rva-bike-month\/$/,
  ];

  let matched = false;
  pagesNotIndexed.forEach((pattern) => {
    if (route.match(pattern)) {
      matched = true;
    }
  });
  return matched;
}



export function canonicalize(route) {
  const canonicalMap = [
    {pattern: '/our-events/friday-cheers-(\\d\\d\\d\\d)/.*', target: '/our-events/friday-cheers-2025/'}
  ]


  let canonicalUrl = '';
  canonicalMap.forEach((mapping) => {
    const re = new RegExp(mapping.pattern, 'i')
    const match = route.match(re)
    // keeping this simple since the site is being redone.
    // Should at most need to update to handle not mucking up
    if (match && match[1] !== "2025") {
      canonicalUrl = mapping.target;
    }
  });
  return canonicalUrl
}



// WEBPACK FOOTER //
// ./src/util/helperFunctions.js